import * as React from 'react'
import { createSvgIcon } from 'material-ui-next/utils'

/**
 * @ignore - internal component.
 */
export default createSvgIcon(<path d="M7 10l5 5 5-5z" />, 'ArrowDropDown')
